import { render, staticRenderFns } from "./CommentAdd.vue?vue&type=template&id=c8758ff6&lang=html&"
import script from "./CommentAdd.vue?vue&type=script&lang=js&"
export * from "./CommentAdd.vue?vue&type=script&lang=js&"
import style0 from "./CommentAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports